import React, { useEffect, useState } from 'react';
import './Confetti.css';

const Confetti = ({ isActive }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (isActive) {
      const newParticles = [];
      for (let i = 0; i < 80; i++) {
        newParticles.push({
          id: i,
          left: Math.random() * 100,
          animationDelay: Math.random() * 1,
          animationDuration: 2 + Math.random() * 2,
          backgroundColor: getRandomColor(),
          shape: Math.random() > 0.5 ? 'square' : 'circle'
        });
      }
      setParticles(newParticles);

      // Clear confetti after animation
      const timer = setTimeout(() => {
        setParticles([]);
      }, 6000);

      return () => clearTimeout(timer);
    } else {
      setParticles([]);
    }
  }, [isActive]);

  const getRandomColor = () => {
    const colors = [
      '#19c37d', '#4CAF50', '#FF6B6B', '#FFD93D', 
      '#6BCF7F', '#4D96FF', '#FF8A65', '#BA68C8',
      '#26C6DA', '#FFA726', '#66BB6A', '#42A5F5'
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  if (!isActive && particles.length === 0) return null;

  return (
    <div className="confetti-container">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className={`confetti-particle ${particle.shape}`}
          style={{
            left: `${particle.left}%`,
            backgroundColor: particle.backgroundColor,
            animationDelay: `${particle.animationDelay}s`,
            animationDuration: `${particle.animationDuration}s`
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;